import {
  BankTransferStatement,
  CreateBankTransferStatementRequest,
} from "@app/types/bank-transfer-statement.type";
import { GetListResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _BankTransferStatementService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<BankTransferStatement>>(
      "/admin/api/v3/bank-transfer-statements",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public create(data: CreateBankTransferStatementRequest) {
    return HttpService.post<BankTransferStatement>(
      "/admin/api/v3/bank-transfer-statements",
      {
        body: {
          ...data,
        },
      }
    );
  }

  public delete(id: number) {
    return HttpService.post(
      `/admin/api/v3/bank-transfer-statements/${id}`
    );
  }
}

const BankTransferStatementService = new _BankTransferStatementService();

export default BankTransferStatementService;
